import AbstractConfig from './AbstractConfig';
import GallerySectionConfig from './GallerySectionConfig';

export default class GalleryConfig extends AbstractConfig {
  public name(): string {
    return this.get('name');
  }

  public description(): string | undefined {
    return this.get('description');
  }

  public sections(): GallerySectionConfig[] {
    return (this.get('sections') || []).map(
      source => new GallerySectionConfig(source)
    );
  }
}
